import { Checkbox, Table, TableContainer, TableHead } from "@mui/material";

import Paper from "@mui/material/Paper";

import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

import { blueGrey, grey } from "@mui/material/colors";
import { Fragment, useEffect, useState } from "react";
import {
  getDatetimeString,
  getYearMonthDateDisplay,
  getYearToSecondDisplay,
} from "../../../utils/utils";

const infoTableCellSx = {
  fontSize: 17,
};

const HistoryTableBody = (props) => {
  const { reports, paging, reportTypes } = props;
  const [isAllChecked, setIsAllChecked] = useState(false);
  useEffect(() => {
    setIsAllChecked(false);
  }, [reports.Value.length]);

  const handleCheckboxChange = (index) => {
    reports.updateIndexProp(
      index,
      "isChecked",
      !reports.Value[index].isChecked
    );
    setIsAllChecked(reports.Value.every((r) => r.isChecked));
  };

  const handleAllChecked = (e) => {
    const newCheckAllState = e.target.checked;
    setIsAllChecked(newCheckAllState);
    const newReports = reports.Value.map((report) => ({
      ...report,
      isChecked: newCheckAllState,
    }));
    reports.setValue(newReports);
  };

  /** 帳票種別IDで検索して帳票種別データ取得 */
  const getReportTypeInfo = (reportTypeId) => {
    return reportTypes.find(
      (reportType) => reportType.reportTypeId === reportTypeId
    );
  };

  /** 帳票キーワードの出力文字列を取得する */
  const getOutputReportKeyWord = (keysStr, valuesStr) => {
    const keys = keysStr.split(",");
    const values = valuesStr.split(",");
    const valuesLen = values.length;

    const keywords = keys.map(
      (key, index) => key + ":" + (valuesLen > index ? values[index] : "")
    );

    return keywords.join("\n");
  };

  const columns = [
    "帳票タイプ",
    "キーワード",
    "ページ数",
    "対象日",
    "出力日時",
  ];

  return (
    <Fragment>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow>
              <TableCell
                key={`selectAllCheck`}
                sx={{
                  ...infoTableCellSx,
                  backgroundColor: grey[100],
                  padding: 0,
                }}
              >
                <Checkbox
                  checked={isAllChecked || false}
                  onChange={handleAllChecked}
                ></Checkbox>
              </TableCell>
              {columns.map((columnName, i) => {
                return (
                  <TableCell
                    key={`${columnName}_${i}`}
                    sx={{ ...infoTableCellSx, backgroundColor: grey[100] }}
                  >
                    {columnName}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {reports.Value.slice(
              (paging.Value.page - 1) * paging.Value.itemsPerPage,
              (paging.Value.page - 1) * paging.Value.itemsPerPage +
                paging.Value.itemsPerPage
            ).map((data, index) => (
              <TableRow
                key={index}
                sx={{
                  "&:hover": {
                    backgroundColor: blueGrey[50],
                  },
                }}
              >
                {/*　選択フラグ */}
                <TableCell
                  component="th"
                  scope="row"
                  sx={{
                    fontWeight: "bold",
                    fontSize: 20,
                    height: 28,
                    width: 15,
                    padding: 0,
                  }}
                >
                  <Checkbox
                    checked={data.isChecked || false}
                    onChange={(e) =>
                      handleCheckboxChange(
                        (paging.Value.page - 1) * paging.Value.itemsPerPage +
                          index
                      )
                    }
                  />
                </TableCell>
                {/* 帳票タイプ */}
                <TableCell sx={{ ...infoTableCellSx, width: 170 }}>
                  {getReportTypeInfo(data.reportTypeId).reportTypeName}
                </TableCell>
                {/* キーワード・値 */}
                <TableCell
                  sx={{
                    ...infoTableCellSx,
                    width: 170,
                    whiteSpace: "pre-wrap",
                  }}
                >
                  {getOutputReportKeyWord(
                    getReportTypeInfo(data.reportTypeId).reportKeyName,
                    data.keyValue
                  )}
                </TableCell>
                {/* ページ数 */}
                <TableCell
                  sx={{ ...infoTableCellSx, width: 50, textAlign: "right" }}
                >
                  {data.pageCount}
                </TableCell>
                {/* 対象日 */}
                <TableCell sx={{ ...infoTableCellSx, width: 150 }}>
                  {getYearMonthDateDisplay(new Date(data.targetDate))}
                </TableCell>
                {/* 出力日時 */}
                <TableCell sx={{ ...infoTableCellSx, width: 150 }}>
                  {getYearToSecondDisplay(new Date(data.exportDate))}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Fragment>
  );
};

export default HistoryTableBody;
